import React from "react";
import { Link } from "react-router-dom";

/**
 * SONMI · The frozen Shared-Surface Discovery studies.
 *
 * A quiet index of the six exploratory prototypes from an earlier
 * phase. They will not be modified. The Grammar and Physics they
 * revealed are the record; these pages are the evidence.
 */

const STUDIES = [
  {
    to: "/sonmi/study/shell",
    name: "Shell",
    note: "the ambient shell composition",
  },
  {
    to: "/sonmi/study/people-vessel",
    name: "People Vessel",
    note: "people rendered as vessel",
  },
  {
    to: "/sonmi/study/expanded",
    name: "Expanded",
    note: "expanded surface state",
  },
  {
    to: "/sonmi/study/vessel",
    name: "Vessel — Additive Agreement",
    note: "thoughts gathering; the shared surface behaves like water",
  },
  {
    to: "/sonmi/study/vessel-correction",
    name: "Vessel — Correction",
    note: "a thought is loosened, not deleted",
  },
  {
    to: "/sonmi/study/vessel-coauthored",
    name: "Vessel — Co-authored",
    note: "the only study that touches an LLM; two minds settle a synthesis",
  },
];

export default function StudiesIndex() {
  return (
    <div
      className="min-h-screen w-full"
      style={{ backgroundColor: "#FAFAF7", fontFamily: "'Outfit', sans-serif", color: "#44403c" }}
      data-testid="studies-index"
    >
      <div className="absolute top-6 left-8 text-[10px] uppercase tracking-[0.18em] text-stone-400">
        SONMI · The Written Record · Frozen Studies
      </div>
      <div className="absolute top-6 right-8">
        <Link
          to="/"
          className="text-[11px] italic text-stone-400 hover:text-stone-700 transition-colors"
          data-testid="studies-back"
        >
          ← Atrium
        </Link>
      </div>

      <div className="max-w-2xl mx-auto px-8 pt-28 pb-24">
        <h1
          className="text-stone-900"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 300,
            fontSize: "2.4rem",
            letterSpacing: "-0.01em",
            lineHeight: 1.15,
          }}
          data-testid="studies-title"
        >
          Frozen Studies
        </h1>
        <p
          className="mt-4 italic text-stone-500"
          style={{ fontSize: "1.05rem", lineHeight: 1.6 }}
          data-testid="studies-note"
        >
          Six exploratory prototypes from the Shared-Surface Discovery phase.
          They are frozen — kept as evidence, not as software to iterate on.
        </p>

        <div
          className="mt-16 border-t"
          style={{ borderColor: "#e7e5e4" }}
        />

        <ol className="mt-16 space-y-12" data-testid="studies-list">
          {STUDIES.map((s, i) => (
            <li key={s.to}>
              <div className="flex items-baseline gap-4">
                <span
                  className="text-stone-300 text-[13px] tabular-nums"
                  style={{ minWidth: "1.5rem" }}
                >
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <Link
                    to={s.to}
                    className="text-stone-800 hover:text-stone-900 transition-colors"
                    style={{
                      fontFamily: "'Cormorant Garamond', serif",
                      fontWeight: 400,
                      fontSize: "1.4rem",
                      letterSpacing: "-0.005em",
                      lineHeight: 1.2,
                    }}
                    data-testid={`study-link-${i}`}
                  >
                    {s.name}
                  </Link>
                  <p
                    className="mt-1 italic text-stone-500"
                    style={{ fontSize: "0.95rem", lineHeight: 1.55 }}
                  >
                    {s.note}
                  </p>
                </div>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
}
